export const GET_PRINCIPAL = 'PRINCIPAL';

export const CUSTOMER = 'customer';
export const CUSTOMERS = 'customers';
export const SET_CUSTOMER = 'SetCustomer';
export const SET_CUSTOMERS = 'SetCustomers';
export const CLEAR_CUSTOMERS = 'clearCustomers';
export const SET_RELOAD_CUSTOMERS = 'SetReloadCustomers';
export const UPDATE_CUSTOMER = 'UpdateCustomer';
export const UPDATE_CUSTOMERS_ZONE = 'UpdateCustomersZone';
export const SET_UPDATING_STATUS = 'setUpdatingStatus';
export const CLEAR_CUSTOMER_FORMS = 'clearCustomerForms';

export const SET_ERROR_LOGS = 'setErrorLogs';

export const SET_FORM = 'SetForm';
export const SET_FORMS = 'SetForms';
export const CLEAR_FORMS = 'clearForms';
export const DELETE_FORM = 'DeleteForm';
export const SET_RELOAD_FORMS = 'SetReloadForms';
export const SET_CURRENT_CUSTOMERS_FORMS = 'SetCurrentCustomersForms';
export const DELETE_PDF_FORM = 'DeletePdfForm';
export const SET_DELETE_PDF_FORM = 'SetDeletePdfForm';

export const SET_RESET_VALUE = 'SetResetValue';
export const SET_CODEMANAGER = 'SetCodeManager';
export const SET_RELOAD_CODEMANAGER = 'SetReloadCodeManager';
export const SET_CODESELECTED = 'SetCodeSelected';
export const RESET_CODESELECTED = 'ResetCodeSelected';

export const SET_SNIPPET = 'SetSnippet';
export const SET_SNIPPETS = 'SetSnippets';

export const SET_CUSTOMER_FORMS = 'SetCustomerForms';
export const SET_CUSTOMER_FORM = 'SetCustomerForm';
export const SET_CUSTOMER_ID = 'SetCustomerId';
export const SET_RELOAD_CUSTOMER_FORMS = 'SetReloadCustomerForms';

export const SET_SHOWMODAL = 'SetShowModal';
export const SET_SHOWFORMSMODAL = 'SetShowFormsModal';

export const SET_CODESELECTED_DETAILS = 'SetCodeSelectedDetails';
export const SET_SHOW_CODE_DETAIL_MODAL = 'SetShowCodeDetailModal';
export const SET_RESET_SNIPPET = 'SetResetCode';
export const SET_IS_ON_ALL_STATUSES = 'SetIsOnAllStatuses';

export const TOAST_MESSAGES_PUSH = 'toastMessages/push';

export const SET_HAS_ERROR = 'SetHasError';
export const HAS_ERROR = 'hasError';

export const SET_HISTORY_LOGS = 'setHistoryLogs';
export const CLEAR_HISTORY_LOGS = 'clearHistoryLogs';
export const SET_USERS = 'setUsers';
export const CLEAR_USERS = 'clearUsers';
export const SET_TRANSACTIONS = 'setTransactions';
export const CLEAR_TRANSACTIONS = 'clearTransactions';

export const SET_MENU = 'setMenu';
export const CLEAR_MENU = 'clearMenu';

export const ADD_CUSTOMERS_COMPANIES_LOCATIONS =
	'AddCustomersCompaniesLocations';
export const CUSTOMERS_COMPANIES_LOCATIONS = 'customersCL';
export const SET_CUSTOMERS_AUTOSUGGESTIONS = 'setCustomersAutosuggestions';
export const CLEAR_CUSTOMERS_AUTOSUGGESTIONS = 'clearCustomersAutosuggestions';
export const UPDATE_ACCORDION_STATUSES = 'updateAccordionStatuses';
export const CLEAR_ACCORDION_STATUSES = 'clearAccordionStatuses';
export const SET_ZONE_HISTORY_LOGS = 'setZoneHistoryLogs';
